import React, {useState, useContext} from "react";
import { Navigate, Link, useLocation, useNavigate } from 'react-router-dom';
import config from "../../js/config_static";
import { Header } from "../components/Header";

import "../css/general.css";
import "./GreetingWindow.css";
import "../auth/Login.css";

import api from "../../js/utils/async/api";

import CredentialsContext from "../contexts/CredentialsContext";

export default function NewUserForm(props) {
  const redirect = "/login";
  const {credentials, setCredentials} = useContext(CredentialsContext);

  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [passwordRep, setPasswordRep] = useState("");
  const [email, setEmail] = useState();
  const [role, setRole] = useState("user");
  const [showPasswd, setShowPasswd] = useState(false);
  const [globalGameCheckBox, setGlobalGameCheckBox] = useState(false);
  const [gameCheckBoxState, setGameCheckBoxState] = useState(new Array(9).fill(false));

  const [dataError, setDataError] = useState();

  const newUserUIConfig = {
    title: "Создание нового пользователя",
    login: config.ui.Login.login,
    passwd: config.ui.Login.password,
    passwdrep: "Повторите пароль",
    username: "",
    defusertype: "user",
    btnvalue: "Добавить пользователя"
  }

  let uiConfig = newUserUIConfig;

  const handleSubmit = async e => {
    e.preventDefault();
    let gameArray = [];
    gameCheckBoxState.forEach((elem, index) => {if(elem) gameArray.push(index)});

    const newUserCredentials = {
      freshName: username,
      freshPassword: password,
      repeatPassword: passwordRep,
      email: "",
      usertype: role,
      games: JSON.stringify(gameArray)
    }

    if(username === ""){
      return setDataError("Поле «Логин» должно быть заполнено");
    }
    if(!/^[a-z0-9_/]+$/.test(username)){
      return setDataError("Поле «Логин» может содержать только строчные английские буквы или цифры");
    }
    if(password === ""){
      return setDataError("Поле «Пароль» должно быть заполнено");
    }
    else if(password.length <= 5){
      return setDataError("Пароль должен быть длиной не менее 6 символов");
    }
    else if(password !== passwordRep){
      return setDataError("Пароли не совпадают");
    }
    else if(!/^[a-z0-9~!@#$%^&*()/]+$/i.test(password)){
      return setDataError("Пароль может содержать только английские буквы и символы ~, !, @, #, $, %, ^, &, *, (, ), /");
    }
    else if(!/[A-Z]+/.test(password)){
      return setDataError("Пароль должен содержать хотя бы одну заглавную букву");
    }
    else if(!/[~!@#$%^&*()/]+/.test(password)){
      return setDataError("Пароль должен содержать хотя бы один символ ~, !, @, #, $, %, ^, &, *, (, ), /");
    }

    try {
      const result = await api.users.save(newUserCredentials, credentials.token); 
      if (result === "ok")
        setDataError(false);
      else 
        throw new Error()
    } catch (error) {
      if (error.match(/email .* already exists!/)) {
        setDataError(`Пользователь с указанным электронным адресом уже существует`);
        return;
      }
      if (error.match(/user .* already exists!/)) {
        setDataError(`Пользователь с указанным условным именем уже существует`);
        return;
      }
      if (error.match(/incorrect password/)) {
        setDataError(`Некорректный пароль`);
        return;
      }
      if (error.match(/incorrect email/)) {
        setDataError(`Некорректный электронный адрес`);
        return;
      }
      setDataError("Ошибка во введённых данных");
    }
  }

  let gameNames = ["Теория государства и права", "Семейный совет", "Уголовный закон", "Криминология или профилактика преступности",
  "Экологический поход", "Основы юридической психологии", "Судебное исследование: фотография", "Основы кримтехники", "Наследование по закону"];

  if (!credentials) {
    return <Navigate to={redirect} /> 
  }

  const handleChange = (position) => {
    const updatedCheckedState = gameCheckBoxState.map((item, index) =>
      index === position ? !item : item
    );
    if(updatedCheckedState.includes(false)){
      setGlobalGameCheckBox(false);
    }
    setGameCheckBoxState(updatedCheckedState);
  }
   
  return (
  <>
  <Header/>
  <div className="centering">
    <div className="loginpanel">
      <div className="title">{uiConfig.title}</div>
      { dataError &&
        <div style={{color: "red", textAlign: "center"}}>{dataError}</div>
      }
      { dataError === false &&
        <div>
          <p style={{ color: "green", textAlign: "center" }}>{"Новый пользователь " + username  + " успешно создан"}</p>
        </div>
      }
      <form onSubmit={handleSubmit}>
        <label htmlFor="username">{uiConfig.login}</label>
        <input
          type="text"
          id="username"
          name="freshName"
          className="form-control"
          defaultValue={uiConfig.username}
          onChange={(e) => setUserName(e.target.value)}
          />
        <br />
        <label htmlFor="password">{uiConfig.passwd}</label>
        <input
          type={showPasswd ? "text" : "password"}
          id="password"
          name="freshPassword"
          className="form-control"
          onChange={(e) => setPassword(e.target.value)}
          />
        <br/>
        <label htmlFor="password">{uiConfig.passwdrep}</label>
        <input
          type={showPasswd ? "text" : "password"}
          id="password1"
          name="freshPassword"
          className="form-control"
          onChange={(e) => setPasswordRep(e.target.value)}
          />
        <br/>
        <div>
          <input type="checkbox" name="showpwd" onChange={() => setShowPasswd((p) => !p)}/>
          <label htmlFor="showpwd">Показать пароль</label>
        </div>
        <br/>
        <label htmlFor="role">Роль пользователя</label>
        <select id="role" name='usertype' className="form-control" defaultValue={uiConfig.defusertype} onChange={(e) => setRole(e.target.value)}>
          <option value="user">Пользователь</option>
          <option value="expert">Эксперт</option>
          <option value="developer">Разработчик</option>
        </select>
        <br/>
        <div>
          <h3 className="centering">Доступ к играм</h3>
          <div>
            <input type="checkbox" name="games" value="Все" checked={globalGameCheckBox} 
            onChange={() =>{gameCheckBoxState.fill(!globalGameCheckBox); setGlobalGameCheckBox(v => !v);}}/>
            <label htmlFor="games">Все</label>
          </div>
          {gameNames.map((elem, index) => <div key={elem}>
            <input type="checkbox" name="elem" value={index} checked={gameCheckBoxState[index]}
            onChange={() =>handleChange(index)}/>
            <label htmlFor="games">{elem}</label>
          </div>)}
        </div>
        <br/>
        <div className="centering">
          <input type="submit" disabled={!gameCheckBoxState.includes(true)} className="btn btn-success" value={uiConfig.btnvalue} />
        </div>
      </form>
    </div>
  </div>
  </>
  );
}
